import {buildVueParcel} from "../base-build-vue-parcel";
import ToolbarLogin from "../../Auth/ToolbarLogin.vue";

const spaconf = {
	name: "auth-toolbar",
	async load() {},
	getAppConfig() {
		return buildVueParcel({
			render: h => {
				console.info("Render Function");
				return h(ToolbarLogin);
			}
		});
	}
};

export const ToolbarLoginApp = spaconf;
